/**
 * Retrieves cart data based on the current page context.
 * @returns {Array} An array containing the cart data.
 */
function getCartData() {
    if (pageContext.ns == 'cart') {
        var productContainers = $('.cart-table .row-product');
    } else {
        var productContainers = $('.mini-cart-flyout-filled .mini-cart-product').not('.mini-cart-gift-cert');
    }
    let cartData = [];
    let currentData;

    for (let i = 0; i < productContainers.length; i++) {
        if (pageContext.ns == 'cart') {
            currentData = dyTracking.getCartProductData($(productContainers[i]));
        } else {
            currentData = dyTracking.getProductData($(productContainers[i]));
        }

        cartData.push(currentData);
    }

    return cartData;
}

function triggerEmail(name, type, email) {
    if (typeof DY !== 'undefined' && typeof DYO !== 'undefined') {
        DY.API('event', {
            name: name,
            properties: {
                dyType: type,
                hashedEmail: DYO.dyhash.sha256(email.toLowerCase())
            }
        });
    }
}

function removeProduct(productData, cartData) {
    DY.API('event', {
        name: 'Remove from Cart',
        properties: {
            dyType: 'remove-from-cart-v1',
            value: productData.value,
            currency: productData.currency,
            productId: productData.productId,
            quantity: productData.quantity,
            size: productData.size,
            cart: cartData
        }
    });
}

function addProduct(productData, cartData) {
    DY.API('event', {
        name: 'Add to Cart',
        properties: {
            dyType: 'add-to-cart-v1',
            value: productData.value,
            currency: productData.currency,
            productId: productData.productId,
            quantity: productData.quantity,
            size: productData.size,
            cart: cartData
        }
    });
}

let dyTracking = {
    purchase: function (dyInput) {
        if (typeof DY !== 'undefined' && dyInput && dyInput.length) {
            var data = JSON.parse(dyInput.val());

            if (data) {
                DY.API('event', {
                    name: data.name,
                    properties: {
                        uniqueTransactionId: data.uniqueTransactionId,
                        dyType: data.dyType,
                        value: data.value,
                        currency: data.currency,
                        cart: JSON.parse(data.cart)
                    }
                });
            }

            if (data.newsletter && data.email) {
                this.trackNewsletter(data.email);
            }
        }
    },
    trackAddToCart: function () {
        if (typeof DY !== 'undefined') {
            var priceVal = $('.component.price').data('price');
            var sizeVal = $('.attribute.size .selection-text').text();
            var price = priceVal ? Number(priceVal) : 0;
            var size = sizeVal ? sizeVal.trim() : '';
            var currency = $('input[name=productCurrency]').val();
            var cartData = getCartData();

            var productData = {
                value: price,
                currency: currency,
                productId: $('#pid').val(),
                quantity: 1,
                size: size
            };
            addProduct(productData, cartData);

            this.syncCart(currency);
            this.setRecommendationsSelector('addToCart');
        }
    },
    trackAddToCartProductSetItem: function (form) {
        if (typeof DY !== 'undefined') {
            var productSetItem = form.parents('.product-set-item');
            var priceVal = productSetItem.find('.component.price').data('price');
            var sizeVal = productSetItem.find('.attribute.size .selection-text').text();
            var price = priceVal ? Number(priceVal) : 0;
            var size = sizeVal ? sizeVal.trim() : '';
            var currency = productSetItem.find('input[name=productCurrency]').val();
            var cartData = getCartData();

            var productData = {
                value: price,
                currency: currency,
                productId: productSetItem.find('input[name=pid]').val(),
                quantity: 1,
                size: size
            };
            addProduct(productData, cartData);

            this.syncCart(currency);
            this.setRecommendationsSelector('addToCart');
        }
    },
    quantityChangeCart: function () {
        if (typeof DY !== 'undefined') {
            var cartData = getCartData();
            var storedpid = sessionStorage.getItem('pid');
            var container = $('input[name="minicartPid"][value="' + storedpid + '"]').closest('.row-product');
            var price = container.find('input[name="totalPrice"]').val();
            var quantity = sessionStorage.getItem('itemsAdded')
                ? sessionStorage.getItem('itemsAdded')
                : sessionStorage.getItem('itemsRemoved');

            let size = container.find('li[data-attribute="size"] span.value').text();
            var currency = $('input[name="currency"]').val();
            var id = container.find('input[name="minicartPid"]').val();

            if (price && price.length) {
                price = Number(price);
            }

            var productData = {
                value: price,
                currency: currency,
                productId: id,
                quantity: Number(quantity),
                size: size
            };
            if (sessionStorage.itemsAdded) {
                if (cartData.length > 0) {
                    addProduct(productData, cartData);
                }
            }
            if (sessionStorage.itemsRemoved) {
                if (cartData.length > 0) {
                    removeProduct(productData, cartData);
                }
            }
        }
    },
    trackMiniCartRemove: function (productData) {
        if (typeof DY !== 'undefined') {
            var cartData = getCartData();

            removeProduct(productData, cartData);

            this.syncCart(productData.currency);
        }
    },
    trackCartRemove: function (container) {
        if (typeof DY !== 'undefined') {
            var price = container.find('input[name="totalPrice"]').val();
            var currency = $('input[name="cartCurrency"]').val();
            var id = container.find('input[name="minicartPid"]').val();
            var qty = container.find('option[selected="selected"]').val();
            var size = container.find('li[data-attribute="size"] span.value').text();
            var trimmedSize = '';

            if (size && size.length) {
                trimmedSize = size.trim();
            }

            if (price && price.length) {
                price = Number(price);
            }

            if (qty && qty.length) {
                qty = Number(qty);
            }

            var cartData = getCartData();
            var alreadyRemoved = '';

            cartData = cartData.filter(el => {
                if (el.productId == id && alreadyRemoved !== id) {
                    alreadyRemoved = id;
                    return false;
                }
                return true;
            });

            var productData = {
                value: price,
                currency: currency,
                productId: id,
                quantity: qty,
                size: trimmedSize
            };

            removeProduct(productData, cartData);
        }
    },
    trackSpa: function () {
        if (typeof DY !== 'undefined') {
            DY.API('spa', {
                context: {
                    type: 'PRODUCT',
                    lng: DY.recommendationContext?.lng,
                    data: [$('#pid').val()]
                },
                url: window.location.href,
                countAsPageview: false
            });
        }
    },
    syncCart: function (currency) {
        if (typeof DY !== 'undefined') {
            var cartData = getCartData();

            if (cartData.length > 0) {
                DY.API('event', {
                    name: 'Sync Cart',
                    properties: {
                        dyType: 'sync-cart-v1',
                        currency: currency,
                        cart: cartData
                    }
                });
            }
        }
    },
    getProductData: function (container) {
        if (typeof DY !== 'undefined') {
            let id = container.find('input[name="minicartPid"]').val();
            let quantityContainer = container.find('.mini-cart-qty-inner');
            let price = 0;
            let quantity = 1;
            let size = '';

            if (quantityContainer.length) {
                quantity = Number(quantityContainer.text().trim().slice(0, -1));
            }

            let priceContainer = container.find('input[name="basePrice"]');

            if (priceContainer.length) {
                price = Number(priceContainer.val().replace(',', '.'));
            }

            let sizeContainer = container.find('li[data-attribute="size"]');

            if (sizeContainer.length) {
                size = sizeContainer.find('span.value').text().trim();
            }

            return {
                productId: id,
                quantity: quantity,
                itemPrice: price,
                size: size
            };
        }

        return {};
    },
    getCartProductData: function (container) {
        if (typeof DY !== 'undefined') {
            let id = container.find('input[name="minicartPid"]').val();
            let quantity = Number(container.find('option[selected="selected"]').val());
            let price = Number(container.find('input[name="totalPrice"]').val());
            let size = container.find('li[data-attribute="size"] span.value').text();

            return {
                productId: id,
                quantity: quantity,
                itemPrice: price,
                size: size
            };
        }

        return {};
    },
    trackNewsletter: function (email) {
        if (typeof DY !== 'undefined') {
            triggerEmail('Newsletter Subscription', 'newsletter-subscription-v1', email);
        }
    },
    trackLogin: function () {
        if (typeof DY !== 'undefined') {
            let loggedEmail = $('input[name="loggedEmail"]');

            if (loggedEmail && loggedEmail.length && loggedEmail.val()) {
                triggerEmail('Login', 'login-v1', loggedEmail.val());
            }
        }
    },
    trackUserEvents: function () {
        if (typeof DY !== 'undefined') {
            let newsLetterInput = $('input[name="subscribedEmail"]');
            let signUpEmail = $('input[name="signUpEmail"]');

            if (newsLetterInput && newsLetterInput.length && newsLetterInput.val()) {
                this.trackNewsletter(newsLetterInput.val());
            }

            this.trackLogin();

            if (signUpEmail && signUpEmail.length && signUpEmail.val()) {
                triggerEmail('Signup', 'signup-v1', signUpEmail.val());
            }
        }
    },
    trackWishlist: function (pid, btn) {
        if (typeof DY !== 'undefined') {
            var size = 'one-size';
            var setContainer = btn.closest('.product-set-item');
            var sizeSelector = '.attribute.size .activeSize .swatchanchor[aria-checked="true"]';
            var sizeContainer;

            if (setContainer && setContainer.length) {
                sizeContainer = setContainer.find(sizeSelector);
            } else {
                sizeContainer = $(sizeSelector);
            }

            if (sizeContainer && sizeContainer.length) {
                var sizeValue = sizeContainer.text();

                if (sizeValue && sizeValue.length) {
                    size = sizeValue.trim();
                }
            }

            DY.API('event', {
                name: 'Add to Wishlist',
                properties: {
                    dyType: 'add-to-wishlist-v1',
                    productId: pid.toString(),
                    size: size
                }
            });
        }
    },
    filterItems: function (value, filterType) {
        if (typeof DY !== 'undefined') {
            DY.API('event', {
                name: 'Filter Items',
                properties: {
                    dyType: 'filter-items-v1',
                    filterType: filterType,
                    filterStringValue: value
                }
            });
        }
    },
    trackSearch: function (keyword) {
        if (typeof DY !== 'undefined') {
            DY.API('event', {
                name: 'Keyword Search',
                properties: {
                    dyType: 'keyword-search-v1',
                    keywords: keyword
                }
            });
        }
    },
    setRecommendationsSelector: function (page) {
        var recommendations;
        var cartEmpty = $('.cart-empty-recommendations');
        var selector = 'recommendations_' + page;
        if (cartEmpty && cartEmpty.length) {
            return;
        }

        if (page == 'addToCart') {
            recommendations = $('.add-to-cart-recommendations').find('[id^=cq_recomm_slot]');
        } else if (page == 'search') {
            recommendations = $('.no-hits-recommendations').find('[id^=cq_recomm_slot]');
        } else {
            recommendations = $('[id^=cq_recomm_slot]').first();
        }

        if (recommendations && recommendations.length && !recommendations.hasClass(selector)) {
            recommendations.addClass(selector);
        }
    },
    setRecentlyViewedSelector: function (page) {
        var recentlyViewed = $('[id^=cq_recomm_slot]').last();
        var selector = 'recentlyviewed_' + page;
        if (recentlyViewed && recentlyViewed.length && !recentlyViewed.hasClass(selector)) {
            recentlyViewed.addClass(selector);
        }
    },
    mapFilters: function (value, lang, filter) {
        var locale = lang.split('_');
        var localeValue = locale[0].toUpperCase();
        var defaultValue;
        var dyFeedMaterialLocalzed = SitePreferences.dyFeedMaterialLocalzed;

        if (localeValue === 'EN') {
            return value;
        }

        if (filter == 'material' && dyFeedMaterialLocalzed) {
            return value;
        }

        var dyFilterConfig = JSON.parse(SitePreferences.dyFilterConfig);
        var filterTypeConfig = dyFilterConfig ? dyFilterConfig[filter] : null;

        if (filterTypeConfig) {
            if (filterTypeConfig.hasOwnProperty(value)) {
                defaultValue = value;
            } else {
                for (let key in filterTypeConfig) {
                    var element = filterTypeConfig[key];
                    if (element.indexOf(value) > -1) {
                        defaultValue = key;
                        break;
                    }
                }
            }
        }

        return typeof defaultValue !== 'undefined' ? defaultValue : value;
    },
    isLocalizableFilter: function (filter) {
        var dyFilterConfig = JSON.parse(SitePreferences.dyFilterConfig);
        var dyFeedMaterialLocalzed = SitePreferences.dyFeedMaterialLocalzed;

        if (filter == 'material' && dyFeedMaterialLocalzed) {
            return true;
        }

        if (dyFilterConfig && dyFilterConfig.hasOwnProperty(filter)) {
            return false;
        }

        return true;
    }
};

module.exports = dyTracking;
